module.exports = __webpack_public_path__ + "static/media/dz.59ec52e8.webp";